import React from 'react'
import useInsuranceMappedFailed from '../../useInsuranceMappedFailed'

export default function RpaClaimGenerateButton(props) {
  const { rpaClaimFormGenerate, pprops: { selectedInsuranceName } } = props
  const { rpaVerificationFailed, insuranceVerificationFailed } = useInsuranceMappedFailed(selectedInsuranceName)

  const handleGenerateClaimForm = () => {
    if (rpaVerificationFailed) {
      insuranceVerificationFailed()
    }
    else {
      rpaClaimFormGenerate()
    }
  }

  return (
    <button className="btn btn-danger mx-lg-3" onClick={handleGenerateClaimForm}>Generate Claim Form</button>
  )
}
